import { Component, OnInit } from '@angular/core';
import { SettingService } from '../../../../../common/services/Setting.service'
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-setting-otp',
  templateUrl: './setting-otp.component.html',
  styleUrls: ['./setting-otp.component.css'],
  providers: [SettingService]
})
export class SettingOtpComponent implements OnInit {
  ngOnInit() {
    this.getListOTP()
  }

  constructor(
    private _fb: FormBuilder,
    private settingService: SettingService,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {
  }

  // tslint:disable-next-line:member-ordering
  public activeGuaraante;
  // tslint:disable-next-line:member-ordering
  public updateInfo;
  // tslint:disable-next-line:member-ordering
  formCratingBatch: FormGroup = this._fb.group({
    new_custommer: [''],
    active_update: [''],
  });

  getListOTP() {
    this.settingService.getInforOTP().subscribe((res) => {
      const result = res.data
      this.formCratingBatch.get('new_custommer').setValue(result.apply_for === 1 ? 'new' : 'update');
      this.activeGuaraante = result.customer_active_guarantee
      this.updateInfo = result.customer_update_info
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      })
    })
  }

  changeConfig() {
    const body = {
      customer_active_guarantee: this.activeGuaraante,
      customer_update_info: this.updateInfo,
      apply_for: this.formCratingBatch.value.new_custommer == 'new' ? 1 : 2
    }
    this.updateListOTP(body)
  }

  updateListOTP(body) {
    this.settingService.updateInforOTP(body).subscribe((res) => {
      if (res.code === 1) {
        this.toastr.success(this.translate.instant('THANH_CONG'), this.translate.instant('THONG_BAO'), {
          timeOut: 4000, positionClass: 'toast-bottom-right'
        })
        this.getListOTP();
      }
    }, (err: any) => {
      this.toastr.success(err, this.translate.instant('THONG_BAO'), {
        timeOut: 4000, positionClass: 'toast-bottom-right'
      })
    })

  }

  reset(e: string) {
    this.formCratingBatch.get('new_custommer').setValue(e);
  }

  changeActiveGuaraante(event: any) {
    this.activeGuaraante = event.target.checked
    this.changeConfig()
  }

  changeUpdateInfo(event: any) {
    this.updateInfo = event.target.checked
    this.changeConfig()
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/setting-otp/setting-otp.component.ts